import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTranslations = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M20 0C8.98 0 0 8.98 0 20s8.98 20 20 20 20-8.98 20-20S31.02 0 20 0zm17.73 18.89h-7.2c-.17-6.67-2-12.36-4.75-15.69a17.77 17.77 0 0 1 11.95 15.69zM18.9 2.4v16.49h-7.2c.27-8.36 3.33-15.33 7.2-16.49zm0 18.71V37.6c-3.87-1.16-6.93-8.13-7.2-16.49h7.2zm2.2 16.49V21.11h7.2c-.27 8.36-3.33 15.33-7.2 16.49zm0-18.71V2.4c3.87 1.16 6.93 8.13 7.2 16.49h-7.2zM14.22 3.2c-2.7 3.33-4.58 9.02-4.75 15.69h-7.2A17.77 17.77 0 0 1 14.22 3.2zM2.27 21.11h7.2c.17 6.67 2 12.36 4.75 15.69A17.77 17.77 0 0 1 2.27 21.11zm23.5 15.69c2.72-3.33 4.59-9.02 4.76-15.69h7.2A17.77 17.77 0 0 1 25.78 36.8z" })
});
export default SvgTranslations;
